import { toggle } from 'el-transition'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    detailsId: String,
  }

  toggleDetails(event) {
    event.preventDefault()

    if (this.detailsIdValue) {
      toggle(document.getElementById(this.detailsIdValue))
    }
  }
}
